import type { ReactNode } from 'react'

/**
 * A small coloured label for a state.
 *
 * Colour is never the only thing carrying the meaning — the word is always
 * there too. Roughly one man in twelve cannot reliably separate the red from
 * the green, and a table whose "receiving" column is a bare dot is a table
 * those readers cannot use.
 *
 * `unknown` has its own tone rather than borrowing the danger one. A send the
 * provider never answered for may have been delivered, and painting it red
 * would assert something the system does not know. It is the tone this product
 * exists to show, so it is not allowed to collapse into "bad".
 */

export type PillTone = 'ok' | 'unknown' | 'warn' | 'danger' | 'neutral'

const TONES: Record<PillTone, string> = {
  ok: 'bg-ok-soft text-ok',
  unknown: 'bg-unknown-soft text-unknown',
  warn: 'bg-warn-soft text-warn',
  danger: 'bg-danger-soft text-danger',
  neutral: 'bg-surface-2 text-t2',
}

export function StatusPill({
  tone,
  children,
}: {
  readonly tone: PillTone
  readonly children: ReactNode
}) {
  return (
    <span
      className={`inline-block rounded-pill px-2 py-0.5 font-semibold text-[12px] ${TONES[tone]}`}
    >
      {children}
    </span>
  )
}
